<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: [],
      timeout: null,
      queryId: 0,
      destroyed: false
    };
  },

  created() {
    GeocoderFactory().then(geocoder => {
      if (this.destroyed) {
        geocoder.cancelAutocomplete();
        return;
      }
      this.geocoder = geocoder;
    });
  },

  beforeDestroy() {
    this.destroyed = true;
    this.clearPending();
  },

  watch: {
    search(val) {
      const selectedText = this.select && typeof this.select === "object"
        ? this.select.text
        : this.select;
      if (typeof val === "string" && val.trim() && val !== selectedText) {
        this.querySelections(val);
      } else if (!val) {
        this.clearPending();
        this.items = [];
        this.loading = false;
      }
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    clearPending() {
      this.queryId += 1;
      if (this.timeout != null) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }
    },

    querySelections(value) {
      this.clearPending();
      const queryId = this.queryId;
      this.loading = true;

      this.timeout = setTimeout(() => {
        this.timeout = null;
        if (!this.geocoder || queryId !== this.queryId) {
          this.loading = false;
          return;
        }
        this.geocoder.autocomplete(value).then(items => {
          if (queryId === this.queryId) {
            this.items = items;
          }
        }).catch(() => {
          if (queryId === this.queryId) {
            this.items = [];
          }
        }).finally(() => {
          if (queryId === this.queryId) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      this.clearPending();
      this.loading = false;
      this.$emit("change", o);
    }
  }
};
</script>
